import Reveal from "@/components/Reveal";

/**
 * A small dark editorial banner used at the top of content pages.
 * Keeps the fixed Header readable on scroll and gives the page a
 * confident opening "spread".
 */
const PageHeader = ({ eyebrow, title, lede, image }) => {
  return (
    <section
      data-testid="page-header"
      className="dark-section relative pt-32 md:pt-44 pb-20 md:pb-28"
    >
      {image && (
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={image}
            alt=""
            aria-hidden
            className="w-full h-full object-cover opacity-25"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(18,18,18,0.55) 0%, rgba(18,18,18,0.85) 100%)",
            }}
          />
        </div>
      )}

      <div className="relative max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal>
          {eyebrow && (
            <p className="hairline opacity-60 mb-6" data-testid="page-eyebrow">
              {eyebrow}
            </p>
          )}
          <h1
            className="font-serif italic text-5xl md:text-7xl lg:text-8xl leading-[0.95] max-w-4xl"
            data-testid="page-title"
          >
            {title}
          </h1>
          {lede && (
            <p
              className="font-serif italic text-xl md:text-2xl opacity-75 mt-8 max-w-2xl leading-relaxed"
              data-testid="page-lede"
            >
              {lede}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};

export default PageHeader;
